export const processString = (str) => {
  return str.toLowerCase().trim().replace(/\s/g, "");
};
